<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>二级商户签约</span>
      <el-steps :active="2" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写签约信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 签约信息确认" icon="el-icon-s-platform"></el-step>
        <el-step title="3 证照资料上传" icon="el-icon-s-check"></el-step>
        <el-step title="4 签约成功" icon="el-icon-success"></el-step>
      </el-steps>
      <el-button class="but2">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">签约信息确认</span>
      </el-button>
      <el-form class="form" :model="signInfo" :rules="rules" ref="signInfo" label-width="160px">
        <el-form-item class="sp3" label="二级商户编号" prop="subMerchantNo" style="margin-top: 20px">
          <el-input v-model="signInfo.subMerchantNo" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="收款账号" prop="account">
          <el-input v-model="signInfo.account" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="随机金额" prop="randomAmount">
          <el-input v-model="signInfo.randomAmount" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center;margin-left: -300px">
          <el-button type="primary" @click="submitForm('signInfo')">签约信息确认</el-button>
        </el-form-item>
      </el-form>
      <div class="note">
        <span>1、短信验证码与随机金额二者必输其一，企业户默认使用随机金额进行验证；</span><br>
        <span>2、二级商户信息同步确认后，还需银行工作人员进行复核，复核通过后会根据二级商户信息同步申请接口上送的审核结果通知地址通知审核结果。</span>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {signConfirm} from "../../../api/system/bank_abc";
import {mapGetters} from "vuex";

export default {
  data(){
    return{
      signInfo: {
        subMerchantNo:'',
        account:'',
        randomAmount:''
      },
      rules:{
        subMerchantNo:[
          { required: true , message:'请输入二级商户编号' , trigger: 'blur'}
        ],
        account:[
          { required: true , message:'请输入收款账号' , trigger: 'blur'}
        ],
        randomAmount:[
          { required: true , message:'请输入随机金额' , trigger: 'blur'}
        ],
      },
      timeLineHeight: ""
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted(){
    this.signInfo.subMerchantNo = this.$route.query.subMerId
    this.signInfo.account = this.$route.query.account
    this.timeLineHeight = document.documentElement.clientHeight -50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    if(this.index === null){
      this.$message({
        type:'error',
        message:'请在财务组织选择页面选取个人所属公司！'
      });
    }
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    submitForm(formName){
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if(valid){
          signConfirm(JSON.stringify(_this.signInfo)).then(
            res => {
              // console.log(res)
              // console.log(JSON.parse(res.data))
              let json = JSON.parse(res.data)
              // console.log(json.ReturnCode)
              if(json.ReturnCode === "0000"){
                this.$message({
                  type:'success',
                  message:'二级商户信息验证成功，请上传资料'
                });
                this.toUpload()
              }else{
                this.$message({
                  type:'error',
                  message: json.ErrorMessage
                })
              }
            }
          )
        }else{
          return false;
        }
      })
    },
    toUpload(){
      this.$router.push({path: '/finance/upload',query:{'subMerId':this.signInfo.subMerchantNo}})
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .sp3{
    margin-left: 70px;
  }
  .note{
    margin-top: 30px;
    padding: 20px 40px;
    background: #f5f7fa;
    color: #ff5000;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
  }
</style>
